export default "__VITE_ASSET__BVCfj6bL__"